import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setCollection(state, collection) {
    state.collection = collection
  },
  updateCollection(state, collection) {
    state.collection = [
      ...state.collection,
      ...collection
    ]
  },
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  updateSearchPreset(state, form) {
    state.form = {
      ...state.form,
      ...form
    }
  },
  setIsLoadingError(state, isError) {
    state.isLoadingError = isError
  },
  setIncludes(state, includes) {
    state.includes = includes
  },
  setPagination(state, pagination) {
    state.pagination = pagination
  },
  setInitialState(state) {
    this.state.orders = {
      ...initialState()
    }
  },
}

export default mutations